import { createAction, createReducer } from 'redux-act'
import Immutable from 'seamless-immutable'


export const key = 'PrintCandidacy'

//
// Initial state
//
const initialState = {
  data: null,
  loaded: false,
}

//
// Actions
//
export const actions = {
  setData: createAction('Page: setData', (data) => ({ data })),
  setLoaded: createAction('Page: setLoaded', (loaded) => ({ loaded })),
}

//
// Reducer
//
export const reducer = createReducer(
  {
    [actions.setData]: (state, { data }) => Immutable.static.merge(state, { data }),
    [actions.setLoaded]: (state, { loaded }) => Immutable.static.merge(state, { loaded }),
  },
  initialState
)

//
// Selectors
//
const root = (state) => state[key]
const isLoaded = (state) => root(state).loaded
const data = (state) => root(state).data

export const selectors = {
  isLoaded,
  data,
}


